/* eslint-disable */
import axios from 'axios';

export const fetchDate = async () => {
  const dateObj = new Date();
  const seconds = Math.floor(dateObj.getTime() / 1000);
  return seconds;
};
 
export const dateBodyTemplate = (rowData) => {
  const date = new Date(rowData.seconds * 1000);
  return date.toLocaleString().toString()
}